import { Fragment } from "react";
import { motion } from "framer-motion";
import { resolveImageUrl } from "@/components/ImageUpload";
import { withBigEmojis } from "@/lib/emoji";

export default function Itinerary({ items, showTimes = true }) {
  const list = (items || []).filter((i) => i.time || i.title);
  if (list.length === 0) return null;

  // CSS grid keeps the time column the SAME width on every row (max-content), so the
  // vertical rule — the content cell's left border — is perfectly straight no matter
  // how big or narrow each hour renders.
  return (
    <section className="py-14 px-6 md:px-10">
      <div className="text-center mb-10">
        <p className="overline">Programa</p>
        <h3 className="headline text-4xl text-ink mt-3">El plan del día</h3>
      </div>
      <div
        className="max-w-md mx-auto grid"
        style={{ gridTemplateColumns: showTimes ? "max-content 1fr" : "1fr" }}
        data-testid="itinerary-list"
      >
        {list.map((it, i) => {
          const isLast = i === list.length - 1;
          const anim = {
            initial: { opacity: 0 },
            whileInView: { opacity: 1 },
            viewport: { once: true },
            transition: { delay: i * 0.08, duration: 0.5 },
          };
          return (
            <Fragment key={i}>
              {showTimes && (
                <motion.div {...anim} className="text-right pr-5 pb-8">
                  <span className="script text-warmgold text-2xl whitespace-nowrap" data-testid="itinerary-time">
                    {it.time || "--"}
                  </span>
                </motion.div>
              )}
              <motion.div
                {...anim}
                className={`relative min-w-0 pb-8 ${showTimes ? "pl-5" : ""} ${
                  showTimes && !isLast ? "border-l border-warmgold/30" : ""
                }`}
              >
                {showTimes && isLast && (
                  <div className="absolute left-0 top-0 h-10 w-px bg-warmgold/30" aria-hidden />
                )}
                {showTimes && (
                  <div className="absolute -left-[6px] top-2.5 w-3 h-3 rounded-full bg-warmgold ring-4 ring-cream z-10" aria-hidden />
                )}
                <div className="flex items-start gap-3">
                  <div className="min-w-0 flex-1">
                    <h4 className="text-lg md:text-xl text-ink leading-snug font-medium" data-testid="itinerary-title">
                      {withBigEmojis(it.title || "Momento")}
                    </h4>
                    {it.description && (
                      <p className="text-inksoft text-sm mt-1 leading-relaxed">{withBigEmojis(it.description)}</p>
                    )}
                  </div>
                  {it.sticker_url && (
                    <img
                      src={resolveImageUrl(it.sticker_url)}
                      alt=""
                      className="shrink-0 self-center -my-3 h-24 sm:h-28 w-auto max-w-[38%] object-contain drop-shadow-md"
                      data-testid="itinerary-sticker"
                    />
                  )}
                </div>
              </motion.div>
            </Fragment>
          );
        })}
      </div>
    </section>
  );
}
